<ng-template #upgradeBtn>
  <button
    class="upgrade-button"
    [class.upgrade-button--custom]="!isTransparentUpgradeButton"
    [attr.data-appearance]="isTransparentUpgradeButton ? upgradeButtonTextColor : null"
    [attr.data-btn-appearance]="!isTransparentUpgradeButton ? upgradeButtonAppearance : null">
    {{ upgradeButtonLabel }}
  </button>
</ng-template>

<div class="cart-control-example" [class.cart-control-example--mobile]="isMobile">
  <div class="line-item">
    <div class="line-item__left">
      <div class="line-item__image">
        <img src="assets/icons/checkout_content_default.png" alt="Product" />
        <span class="line-item__quantity-badge">1</span>
      </div>
      <div class="line-item__details">
        <span class="line-item__title">
          @if (isMobile) {
            <span class="line-item__title-name">Monstera Deliciosa</span>
            <span class="line-item__title-price">$100.00</span>
          } @else {
            <span class="line-item__title-name line-item__title-name--combined"
              >Monstera Deliciosa<span class="line-item__title-spacer"></span>$100.00</span
            >
          }
        </span>
        <span class="line-item__variant">2 feet</span>
        @if (hasAnyOption) {
          @if (!isOnlyUpgradeButton) {
            <div class="edit-toggle" [attr.data-appearance]="buttonAppearance" (click)="!isOnlyRemove && toggleEdit()">
              <span class="edit-toggle__text" [class.edit-toggle__text--remove]="isOnlyRemove">
                {{ isOnlyRemove ? 'Remove' : buttonLabel }}
              </span>
              @if (!isOnlyRemove) {
                <span class="edit-toggle__icon" [class.open]="isEditOpen">
                  <pdq-icon icon="arrow_down" size="small"></pdq-icon>
                </span>
              }
            </div>
          }

          @if (isOnlyUpgradeButton) {
            <ng-container *ngTemplateOutlet="upgradeBtn"></ng-container>
          } @else {
            @if (showUpgradeButton && (!isEditOpen || isOnlyRemove)) {
              <ng-container *ngTemplateOutlet="upgradeBtn"></ng-container>
            }

            @if (isEditOpen && !isOnlyRemove) {
              <div class="edit-panel">
                @if (changeVariant) {
                  <div class="edit-panel__field">
                    <div class="edit-panel__select">
                      <div class="edit-panel__select-content">
                        <span class="edit-panel__select-title">Variant</span>
                        <span class="edit-panel__select-value">Big green leaves</span>
                      </div>
                      <pdq-icon icon="arrow_down" size="small"></pdq-icon>
                    </div>
                  </div>
                }

                @if (showSubscriptionSelect) {
                  <div class="edit-panel__field">
                    <div class="edit-panel__select">
                      <div class="edit-panel__select-content">
                        <span class="edit-panel__select-title">Subscription</span>
                        <span class="edit-panel__select-value">One time purchase</span>
                      </div>
                      <pdq-icon icon="arrow_down" size="small"></pdq-icon>
                    </div>
                  </div>
                }

                @if (
                  editQuantity ||
                  (removeItems &&
                    !isOnlyRemove &&
                    !editQuantity &&
                    subscriptionSelectorType !== SubscriptionSelectorType.DEFAULT_SELECTOR)
                ) {
                  <div class="edit-panel__quantity-row" [class.edit-panel__quantity-row--mobile]="isMobile">
                    @if (editQuantity) {
                      <div class="edit-panel__field edit-panel__field--quantity">
                        <div class="quantity-stepper">
                          <div class="quantity-stepper__content">
                            <span class="quantity-stepper__title">Quantity</span>
                            <span class="quantity-stepper__value">1</span>
                          </div>
                          <button class="quantity-stepper__btn">−</button>
                          <button class="quantity-stepper__btn">+</button>
                        </div>
                      </div>
                    }
                    @if (removeItems && !isOnlyRemove && editQuantity) {
                      <button class="remove-button">Remove</button>
                    }
                    @if (
                      removeItems &&
                      !isOnlyRemove &&
                      !editQuantity &&
                      subscriptionSelectorType !== SubscriptionSelectorType.DEFAULT_SELECTOR
                    ) {
                      <button class="remove-button">Remove</button>
                    }
                  </div>
                }

                @if (
                  removeItems &&
                  !isOnlyRemove &&
                  subscriptionSelectorType === SubscriptionSelectorType.DEFAULT_SELECTOR &&
                  !editQuantity
                ) {
                  <button class="remove-button">Remove</button>
                }
              </div>

              @if (showUpgradeButton) {
                <ng-container *ngTemplateOutlet="upgradeBtn"></ng-container>
              }
            }
          }
        }
      </div>
    </div>
  </div>

  <div class="checkout-demo">
    <div class="checkout-demo__row-1">
      <div class="checkout-demo__row-1-rect">
        <div class="checkout-demo__row-1-inner"></div>
      </div>
      <div class="checkout-demo__row-1-right"></div>
    </div>
    <div class="checkout-demo__row-2-3">
      <div class="checkout-demo__row-2-3-left"></div>
      <div class="checkout-demo__row-2-3-right"></div>
    </div>
    <div class="checkout-demo__row-2-3">
      <div class="checkout-demo__row-2-3-left"></div>
      <div class="checkout-demo__row-2-3-right"></div>
    </div>
    <div class="checkout-demo__row-4">
      <div class="checkout-demo__row-4-left"></div>
      <div class="checkout-demo__row-4-right"></div>
    </div>
  </div>
</div>
